// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import MestorozhdeniyaForm from './MestorozhdeniyaForm';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(MestorozhdeniyaForm);
